<span
        class="camera-direction-indicator"
        *ngIf="display; else unknownDirection"
        [attr.data-direction]="display.code"
        [attr.title]="display.label"
        [attr.aria-label]="display.label">
    <fa-icon
            class="camera-direction-indicator__icon"
            [icon]="['fas', display.icon]"
            aria-hidden="true"></fa-icon>
    <span class="camera-direction-indicator__label">{{ display.label }}</span>
</span>

<ng-template #unknownDirection>
    <span
            class="camera-direction-indicator camera-direction-indicator--unknown"
            data-direction="unknown"
            aria-label="Direction not available">
        <span class="camera-direction-indicator__label">{{ fallbackLabel }}</span>
    </span>
</ng-template>
